import * as React from "react";

import { IThemeInterface, ThemeProvider } from "~/styled";

import { NormalizedCacheObject } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { HashRouter } from "react-router-dom";
import Routes from "~/routes";

interface IProps {
  client: ApolloClient<NormalizedCacheObject>;
  theme: IThemeInterface;
}

export default class Root extends React.Component<IProps> {
  public render() {
    const { client, theme } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <ApolloProvider client={client}>
          <HashRouter>
            <Routes />
          </HashRouter>
        </ApolloProvider>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Root.tsx